import React, { useEffect, useRef, useState } from "react";
import "./AccountsDrawer.css";
import placeholderProfile from "../../assets/placeholder-profile.png";

const TRANSITION_MS = 300;

function AccountsDrawer({
  open,
  onClose,
  accounts = [],
  currentAccount,
  onSwitchAccount
}) {
  const drawerRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(open);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      document.body.classList.add("no-scroll");
    } else {
      const t = setTimeout(() => {
        setShouldRender(false);
        document.body.classList.remove("no-scroll");
      }, TRANSITION_MS);

      return () => clearTimeout(t);
    }
  }, [open]);

  if (!shouldRender) return null;

  return (
    <div className={`accounts-backdrop ${open ? "open" : "closing"}`} onClick={onClose}>
      <div
        ref={drawerRef}
        className={`accounts-drawer ${open ? "open" : "closing"}`}
        onClick={(e) => e.stopPropagation()}
      >

        <div className="accounts-handle" />

        <div className="accounts-title">
          Accounts
        </div>

        <div className="accounts-list">

          {accounts.map((acc) => {
            const avatar =
              acc.profilePic ||
              acc.avatar ||
              placeholderProfile;

            const name =
              acc.name ||
              acc.username ||
              "Account";

            const isCurrent =
              currentAccount &&
              acc.id === currentAccount.id;

            return (
              <div
                key={acc.id}
                className={`accounts-item ${isCurrent ? "active" : ""}`}
                onClick={() => !isCurrent && onSwitchAccount(acc)}
              >
                <img
                  src={avatar}
                  alt={name}
                  className="accounts-avatar"
                />

                <div className="accounts-name">
                  {name}
                </div>

                {isCurrent && (
                  <div className="accounts-check">✓</div>
                )}
              </div>
            );
          })}

        </div>

      </div>
    </div>
  );
}

export default AccountsDrawer;
